"use strict";

module.exports = {
  'spacing-tiny': '2px',
  'spacing-xxxs': '4px',
  'spacing-xxs': '8px',
  'spacing-xs': '12px',
  'spacing-s': '16px',
  'spacing-m': '20px',
  'spacing-l': '24px',
  'spacing-xl': '32px',
  'spacing-xxl': '48px',
  'spacing-xxxl': '64px',
  'spacing-huge': '128px'
};